import FormTextTC from "../../../components/Forms/FormTextTC";
import React from "react";

export default function DojoEcommerce() {
  return (
    <FormTextTC
      name={"apiaccounts__dojo.dojo_api_token"}
      tDefault={"Dojo API Token"}
      tKey={"vestigingen.form.primairbetallingsverkeer.label.dojo_api_token"}
    />
  );
}
